/**
 * Overview promo visibility — expiry (America/Los_Angeles) + session dismiss.
 */
(function () {
  'use strict';

  var TZ = 'America/Los_Angeles';

  function zoneAsUtcMs(ms) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(new Date(ms));
    var map = {};
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].type !== 'literal') map[parts[i].type] = parts[i].value;
    }
    var hour = parseInt(map.hour, 10);
    if (hour === 24) hour = 0;
    return Date.UTC(
      parseInt(map.year, 10),
      parseInt(map.month, 10) - 1,
      parseInt(map.day, 10),
      hour,
      parseInt(map.minute, 10),
      parseInt(map.second, 10)
    );
  }

  function zoneLocalToUtcMs(localIso) {
    var m = String(localIso || '')
      .trim()
      .match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/);
    if (!m) return 0;
    var utcGuess = Date.UTC(
      parseInt(m[1], 10),
      parseInt(m[2], 10) - 1,
      parseInt(m[3], 10),
      parseInt(m[4], 10),
      parseInt(m[5], 10),
      parseInt(m[6] || '0', 10)
    );
    return utcGuess + (utcGuess - zoneAsUtcMs(utcGuess));
  }

  function isExpired(localIso) {
    var endMs = zoneLocalToUtcMs(localIso);
    return endMs > 0 && Date.now() >= endMs;
  }

  function remainingSec(localIso) {
    var endMs = zoneLocalToUtcMs(localIso);
    if (!endMs) return null;
    return Math.max(0, Math.floor((endMs - Date.now()) / 1000));
  }

  function isDismissed(key) {
    if (!key) return false;
    try {
      return sessionStorage.getItem(key) === '1';
    } catch (e) {
      return false;
    }
  }

  function isSampleTitle(title) {
    var key = String(title || '').toLowerCase();
    return (
      key.indexOf('sample') !== -1 ||
      key.indexOf('échantillon') !== -1 ||
      key.indexOf('echantillon') !== -1
    );
  }

  function isSampleVariantActive(el) {
    var productRoot =
      (el && el.closest('[id^="ProductOverview-"]')) ||
      (el && el.closest('[id^="ProductCeramics-"]')) ||
      (el && el.closest('[id^="shopify-section-"]')) ||
      document;

    var checkedSample = productRoot.querySelector(
      '.po-variant-value--sample input:checked, input:checked + label.po-variant-sample'
    );
    if (checkedSample) return true;

    var checkedOption = productRoot.querySelector(
      'input[type="radio"][name^="options["]:checked'
    );
    if (checkedOption && isSampleTitle(checkedOption.value)) return true;

    var variantInput = productRoot.querySelector('[name="id"]');
    if (variantInput && variantInput.selectedOptions && variantInput.selectedOptions[0]) {
      return isSampleTitle(variantInput.selectedOptions[0].textContent);
    }

    return false;
  }

  function hidePromo(el, reason) {
    el.hidden = true;
    el.setAttribute('hidden', '');
    el.setAttribute('aria-hidden', 'true');
    el.classList.remove('is-overview-promo-visible');
    el.classList.add('is-overview-promo-pending');
    el.style.setProperty('display', 'none', 'important');
    if (reason) el.setAttribute('data-overview-promo-' + reason, '1');
  }

  function showPromo(el) {
    el.removeAttribute('hidden');
    el.removeAttribute('aria-hidden');
    el.hidden = false;
    el.classList.add('is-overview-promo-visible');
    el.classList.remove('is-overview-promo-pending');
    el.style.removeProperty('display');
  }

  function applyTo(el) {
    if (!el || !el.hasAttribute('data-overview-promo')) return;

    var endsAt = el.getAttribute('data-promo-ends-at');
    var key = el.getAttribute('data-promo-storage-key');

    el.removeAttribute('data-overview-promo-expired');
    el.removeAttribute('data-overview-promo-dismissed');
    el.removeAttribute('data-overview-promo-sample');

    if (isSampleVariantActive(el)) {
      hidePromo(el, 'sample');
      return;
    }

    if (endsAt && isExpired(endsAt)) {
      hidePromo(el, 'expired');
      return;
    }

    if (isDismissed(key)) {
      hidePromo(el, 'dismissed');
      return;
    }

    showPromo(el);
  }

  function scan() {
    var nodes = document.querySelectorAll('[data-overview-promo]');
    for (var i = 0; i < nodes.length; i++) {
      applyTo(nodes[i]);
    }
  }

  function boot() {
    scan();
    if (!window.__bsOverviewPromoTick) {
      window.__bsOverviewPromoTick = setInterval(scan, 1000);
    }
  }

  window.__bsOverviewPromo = {
    TZ: TZ,
    zoneLocalToUtcMs: zoneLocalToUtcMs,
    endMs: zoneLocalToUtcMs,
    isExpired: isExpired,
    remainingSec: remainingSec,
    isDismissed: isDismissed,
    applyTo: applyTo,
    scan: scan,
    boot: boot
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:reorder', boot);

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches) return;
    if (
      target.matches('input[type="radio"][name^="options["]') ||
      target.matches('[name="id"]')
    ) {
      scan();
    }
  });
})();
